import { OcapiHeader } from '../types/ocapi-header';
/**
 * Gets the `Headers` that apply to all API requests.
 */
export const getGlobalHeaders = (config) => {
    const { regionCode, tenantId } = config;
    const headers = new Headers();
    headers.append(OcapiHeader.Accept, 'application/json');
    if (regionCode)
        headers.append(OcapiHeader.RegionCode, regionCode);
    if (tenantId)
        headers.append(OcapiHeader.TenantId, tenantId);
    return headers;
};
//# sourceMappingURL=get-global-headers.js.map